import { useState } from 'react';

import { OdinIcon, OdinIconSize } from '@myosh/odin-components';
import { t } from 'i18next';
import { DeleteLayoutConfirmation } from '../common/delete-layout-confirmation';
import { DeleteTabHeaderProps } from './tab-header-element.component';

export const DeleteTabIcon = ({ updateLayout, title, onlyIcon = true }: DeleteTabHeaderProps) => {
  const [deleteConfirmation, setDeleteConfirmation] = useState<boolean>(false);
  return (
    <>
      <div
        className="flex p-1 align-middle"
        onClick={() => {
          setDeleteConfirmation(true);
        }}
      >
        <OdinIcon className="self-center" icon="Trash" size={OdinIconSize.ExtraSmall} />
        {!onlyIcon && <div className="ml-2">{String(t('delete'))}</div>}
      </div>
      <DeleteLayoutConfirmation
        showConfirm={deleteConfirmation}
        setIsVisible={setDeleteConfirmation}
        onDeleteConfirmation={() => updateLayout({}, true)}
        tabName={title}
      />
    </>
  );
};
